// Module
var code = "<span ng-bind-html=\"$ctrl.highlightedText\"></span> ";
// Exports
module.exports = code;